export const storeName = 'store-details';

export default {
    LOAD_STORE_DETAILS: `${storeName}.LOAD_STORE_DETAILS`,
    SET_STORE_DETAILS: `${storeName}.SET_STORE_DETAILS`,
    SET_ERROR: `${storeName}.SET_ERROR`,
};
